import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {IComment, ICommentAPI} from "./comment.interface";

@Injectable()
export class CommentService {
  constructor(private http: HttpClient) {
  }

  list(page: number = 1, status?: string): Observable<ICommentAPI> {
    const params = {page}
    if (status) {
      Object.assign(params, {status: status});
    }
    return this.http.get<ICommentAPI>(`${environment.apiEndpoint}/comments`, {params});
  }

  // Replies as the signed-in admin; the backend notifies the comment author.
  reply(id: IComment['id'], message: string): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${environment.apiEndpoint}/comments/${id}/reply`, {message});
  }

  delete(id: IComment['id']): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/comments/${id}`);
  }

  update(id: IComment['id'], status: boolean): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/comments/${id}/status`, {status});
  }

}
